// Real content for The Cozy Nest, Santa Maria a Monte (PI) — photos & data from the owners' Booking listing.
const BK = (id, k) => `https://cf.bstatic.com/xdata/images/hotel/max1024x768/${id}.jpg?k=${k}&o=`;

export const IMAGES = {
  exterior: BK("886866367", "b326217121100353ac151f434106524dde27dad595371a955f11a1cd1b32e3c0"),
  living: BK("929579094", "6904f3e34d8ec9bcd10ca6d79045bd2e4a2467adff36641b33fa99091357381f"),
  bedroom1: BK("929579101", "ebe7f9330e813d65dc9e1392c102fbf49fa7f7b1a0060df8847de37373183d25"),
  bedroom2: BK("929579104", "c009d7af86327ddeb3dbcca01735518fef2a0fe33276f21dd54403f987b994a1"),
  kitchen: BK("929579100", "e0aecd06271518eadf9c702fb2b0d522c71b1bd2d005b3312eddf80752ff268b"),
  garden: BK("929579082", "e8a15071d2d4516dab5225fc15468022fa7cc182c09aa299d717fca008bb49fd"),
  bathroom: BK("929579089", "c4e68a1b59029fe09e3e3b39046beacc07b52faba1fda2578e55fb457bdf79d1"),
  bathroom2: BK("844249219", "8f50e5b2684fad05480e2e1fa7b80ddd95d10a0cf3b0af011e735887dd69a710"),
};

// hero uses the signature exterior shot
export const HERO_IMAGE = IMAGES.exterior;

// category keys match gallery.filters: interior, rooms, kitchen, outdoor
export const GALLERY = [
  { src: IMAGES.living, cat: "interior", span: "lg:col-span-7 lg:row-span-2" },
  { src: IMAGES.garden, cat: "outdoor", span: "lg:col-span-5" },
  { src: IMAGES.bedroom1, cat: "rooms", span: "lg:col-span-5" },
  { src: IMAGES.kitchen, cat: "kitchen", span: "lg:col-span-4" },
  { src: IMAGES.bathroom, cat: "interior", span: "lg:col-span-4" },
  { src: IMAGES.bedroom2, cat: "rooms", span: "lg:col-span-4" },
  { src: IMAGES.bathroom2, cat: "interior", span: "lg:col-span-6" },
  { src: IMAGES.exterior, cat: "outdoor", span: "lg:col-span-6" },
];

// amenities: lucide icon name + translation key — real facilities
export const AMENITIES = [
  { icon: "Wifi", key: "wifi" },
  { icon: "Snowflake", key: "ac" },
  { icon: "CookingPot", key: "kitchen" },
  { icon: "Car", key: "parking" },
  { icon: "Trees", key: "garden" },
  { icon: "Armchair", key: "terrace" },
  { icon: "Utensils", key: "dining" },
  { icon: "ShowerHead", key: "bathroom" },
  { icon: "Bike", key: "bikes" },
];

export const POIS = [
  { key: "bar", m: 100, icon: "Coffee", lat: 43.6422, lng: 10.6912 },
  { key: "alimentari", m: 200, icon: "ShoppingBasket", lat: 43.6431, lng: 10.6928 },
  { key: "farmacia", m: 200, icon: "Pill", lat: 43.6415, lng: 10.6935 },
  { key: "center", min: 5, icon: "Landmark", car: true, lat: 43.6413, lng: 10.6920 },
  { key: "trattoria", min: 5, icon: "UtensilsCrossed", car: true, lat: 43.6408, lng: 10.6924 },
  { key: "station", min: 10, icon: "TrainFront", car: true, lat: 43.6707, lng: 10.7372 },
  { key: "pontedera", min: 15, icon: "TrainFront", car: true, lat: 43.6626, lng: 10.6349 },
  { key: "pisa", min: 30, icon: "Car", car: true, lat: 43.7228, lng: 10.3966 },
  { key: "lucca", min: 35, icon: "Car", car: true, lat: 43.8430, lng: 10.5027 },
  { key: "lajatico", min: 40, icon: "Music", car: true, lat: 43.4810, lng: 10.7330 },
  { key: "volterra", min: 50, icon: "Castle", car: true, lat: 43.4027, lng: 10.8606 },
  { key: "firenze", min: 50, icon: "Car", car: true, lat: 43.7696, lng: 11.2558 },
  { key: "sangimignano", min: 60, icon: "Castle", car: true, lat: 43.4677, lng: 11.0431 },
  { key: "siena", min: 75, icon: "Landmark", car: true, lat: 43.3188, lng: 11.3308 },
];

export const RULES = [
  { key: "checkin", icon: "LogIn" },
  { key: "checkout", icon: "LogOut" },
  { key: "nosmoking", icon: "CigaretteOff" },
  { key: "pets", icon: "PawPrint" },
  { key: "quiet", icon: "Moon" },
  { key: "noparties", icon: "PartyPopper" },
];

// Real guest reviews from Booking.com and Airbnb (kept in their original language).
export const REVIEWS = [
  {
    id: "franco", name: "Franco", flag: "🇮🇹", rating: 5, source: "Booking.com",
    text: "Ci siamo recati a Santa Maria a Monte per il weekend. Appartamento strepitoso, pulitissimo, appena ristrutturato in modo eccellente. La cortesia della signora Gianna e del marito ci hanno fatto sentire a casa.",
  },
  {
    id: "baptiste", name: "Baptiste", flag: "🇫🇷", rating: 5, source: "Booking.com",
    text: "Super accueil de la propriétaire, logement au top ! Santa Maria est très bien placé pour visiter la Toscane. Je recommande.",
  },
  {
    id: "giorgia", name: "Giorgia", flag: "🇮🇹", rating: 5, source: "Booking.com",
    text: "Struttura bellissima, tutta nuova. Cucina e bagno super serviti, letto comodissimo. I due host gentilissimi e super disponibili. L'unica pecca è stata rimanere solo una notte! Da ripetere sicuramente.",
  },
  {
    id: "bernardo", name: "Bernardo", flag: "🇮🇹", rating: 5, source: "Booking.com",
    text: "Tutto perfetto. Proprietari gentilissimi e appartamento nuovo e pulitissimo, in una posizione strategica per raggiungere molte località turistiche in pochi minuti. È stato un piacere passare la serata qui.",
  },
  {
    id: "firenze", name: "Firenze", flag: "🇮🇹", rating: 5, source: "Booking.com",
    text: "Molto gentili i proprietari, disponibili e professionali: un bel 10 per loro. Grazie, alla prossima!",
  },
  {
    id: "juan", name: "Juan", flag: "🇪🇸", rating: 5, source: "Airbnb",
    text: "Tutto fantastico, come in famiglia, non possiamo che essere grati.",
  },
  {
    id: "guillaume", name: "Guillaume", flag: "🇫🇷", rating: 5, source: "Airbnb",
    text: "Appartamento molto ben arredato, con numerosi servizi. Host accogliente e cordiale, lo consiglio!",
  },
  {
    id: "leonardo", name: "Leonardo", flag: "🇮🇹", rating: 5, source: "Airbnb",
    text: "Bellissimo mini appartamento totalmente nuovo, accogliente e pulito.",
  },
];
